module.exports = __webpack_public_path__ + "static/media/smimage.24c36565.png";